// action
import {
  GET_APPOINTMENT_LIST,
  GET_APPOINTMENT_LIST_FAIL,
  GET_APPOINTMENT_LIST_SUCCESS,
  GET_APPOINTMENT_LIST_RESET,
} from "../action/getAppointmentListAction";

import { api_err_msg } from "../strings.json";

// initialState
const initialState = {
  apiState: "",
  list: [],
  pagination: {},
  message: "",
};

export default function (state = initialState, action) {
  // console.log('action.type',action.type);
  switch (action.type) {
    case GET_APPOINTMENT_LIST:
      return {
        ...state,
        apiState: "loading",
      };
    case GET_APPOINTMENT_LIST_FAIL:
      return {
        ...state,
        apiState: "error",
        message:
          (action.response &&
            action.response.data &&
            action.response.data.message) ||
          api_err_msg,
      };
    case GET_APPOINTMENT_LIST_SUCCESS:
      return {
        ...state,
        apiState: "success",
        list: action.response.data.data.result,
        pagination: action.response.data.data.pagination,
      };
    case GET_APPOINTMENT_LIST_RESET:
      return initialState;
    default:
      return state;
  }
}
